// src/slices/itemSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const fetchItemDetails = createAsyncThunk(
  'item/fetchItemDetails',
  async (menuId) => {
    const res = await axios.get(`${window.BASE_API_URL}getMenuModifierByMenuId/${menuId}`);
    return res.data.data;
  }
);

const itemSlice = createSlice({
  name: 'item',
  initialState: {
    item: null,
    modifiers: [],
    loading: false,
    error: null,
    selections: {},
    quantity: 1,
  },
  reducers: {
    toggleOption(state, action) {
      const { groupId, optionId, maxSelect, singleSelect } = action.payload;

      // Ensure groupSelections exists
      if (!state.selections[groupId]) {
        state.selections[groupId] = {};
      }

      const groupSelections = state.selections[groupId];
      const isSelected = groupSelections[optionId];

      if (isSelected) {
        // Remove selection
        delete groupSelections[optionId];

        // If group is now empty, remove group entirely
        if (Object.keys(groupSelections).length === 0) {
          delete state.selections[groupId];
        }
      } else {
        if (singleSelect) {
          // Replace group with only selected option
          state.selections[groupId] = { [optionId]: 1 };
        } else {
          const selectedCount = Object.keys(groupSelections).length;
          if (selectedCount < maxSelect) {
            groupSelections[optionId] = 1;
          }
        }
      }
    },

    incrementQuantity(state, action) {
      const { groupId, optionId } = action.payload;
      if (state.selections[groupId]?.[optionId] != null) {
        state.selections[groupId][optionId] += 1;
      }
    },

    decrementQuantity(state, action) {
      const { groupId, optionId } = action.payload;
      if (state.selections[groupId]?.[optionId] != null) {
        if (state.selections[groupId][optionId] > 1) {
          state.selections[groupId][optionId] -= 1;
        } else {
          // Remove if value becomes 0 or less
          delete state.selections[groupId][optionId];
          if (Object.keys(state.selections[groupId]).length === 0) {
            delete state.selections[groupId];
          }
        }
      }
    },

    incrementItemQuantity(state) {
      state.quantity += 1;
    },

    decrementItemQuantity(state) {
      if (state.quantity > 1) {
        state.quantity -= 1;
      }
    },

    clearItem(state) {
      state.item = null;
      state.modifiers = [];
      state.selections = {};
      state.quantity = 1;
    },

    setItemData: (state, action) => {
  state.item = {
    id: action.payload.item.itemId,
    category_id: action.payload.item.category_id,
    menu_tags: action.payload.item.menu_tags,
    type: action.payload.item.type,
    name: action.payload.item.name,
    image: action.payload.item.image,
    exclusion: action.payload.item.exclusion,
    basePrice: action.payload.item.basePrice
  };
  state.selections = action.payload.selections || {};
  state.quantity = action.payload.quantity || 1;
}
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchItemDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.item = null;
        state.modifiers = [];
        state.selections = {};
        state.quantity = 1;
      })
      .addCase(fetchItemDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.item = action.payload.menu;
        state.modifiers = action.payload.modifier || [];
      })
      .addCase(fetchItemDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const {
  setItemData,
  toggleOption,
  incrementQuantity,
  decrementQuantity,
  clearItem,
  incrementItemQuantity,
  decrementItemQuantity,
} = itemSlice.actions;

export default itemSlice.reducer;
